module.exports = __webpack_public_path__ + "img/bicycle.8b775c76.svg";